import { variables } from "../variables";

export default {
    state: {
        menuIndex: 1,
        filterData: [],
        titularDocs:{
            titularSol: false,
            titularPerso: false,
            titularDom: false,
            titularLab: false,
            titularFact: false
        }
    },
    getters: {
        getFilterData(state){
            return state.filterData;
        },
        getTitularDocs(state){
            return state.titularDocs
        },
        getMenuIndex(state){
            return state.menuIndex;
        }
    },
    mutations: {
        setFilterData(state, value){
            state.filterData = value
        },
        setTitularDocs(state, value){
            state.titularDocs=value
        },
        setMenuIndex(state, value){
            state.menuIndex = value;
        }
    },
    actions: {
        async getDailyStatistics(context, date){
            return await context.rootGetters.api.get(variables.serverUrl+`/api/v1/applications/daily-statistics?day=${date}`);
        },
        async getMonthlyStatistics(context, {month, year}){
            return await context.rootGetters.api.get(variables.serverUrl+`/api/v1/applications/monthly-statistics?month=${month}&year=${year}`);
        },
        async getLocationSpecific(context, id){
            let response =  await context.rootGetters.api.get(variables.serverUrl+`/api/v1/locations/${id}/specific`);
            return response
        },
        async sendReminderComite(context, data){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applications/${data.id}/vote-reminder`)
        }
    }
}